export interface AutoAttendantPromptItemView {
   autoAttendantPromptId: number;
   extensionAutoAttendantId: number;
   prompt: PromptViewModel;
   sortId: number;
   isDeleted: boolean;
}

export interface PromptViewModel {
   promptId: number;
   name: string;
   file: PromptFileViewModel | null;
}

export interface PromptFileViewModel {
   fileToken: string;
}

export const autoAttendantPromptFields: string[] = [
   'autoAttendantPromptId',
   'extensionAutoAttendantId',
   'promptId',
   'sortId',
];
